import React from "react";

export default function NotFoundPage() {
	return (
		<div className="bg-surface font-body text-on-surface min-h-screen flex flex-col">
			<main className="flex-grow pt-32 pb-12 px-8 flex flex-col justify-center items-center">
				<div className="max-w-7xl w-full grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
					<div className="lg:col-span-12 mt-20 text-center lg:text-left">
						<h1 className="font-headline font-extrabold text-[8rem] md:text-[12rem] leading-none text-primary tracking-tighter opacity-10 select-none">404</h1>
						<div className="-mt-16 md:-mt-24">
							<h2 className="font-headline font-bold text-4xl md:text-6xl text-on-surface leading-tight mb-6">This Page Does Not Exist</h2>
							<p className="text-lg md:text-xl text-on-surface-variant max-w-xl leading-relaxed mb-10 mx-auto lg:mx-0">Sorry, the page you are looking for could not be found. It's just an accident that was not intentional.</p>
						</div>
					</div>
				</div>
			</main>
		</div>
	);
}
